const shadowTypes = {
  shadowPrimary: {
    shadowColor: '#2369FF52',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 1,
    shadowRadius: 4,
    elevation: 5,
  },
  shadowSecondary: {
    shadowColor: '#2369FF52',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 1,
    shadowRadius: 4,
    elevation: 5,
  },
}

export { shadowTypes }
